export const pixelToInt = (pixelValue: string): number => Number(pixelValue.replace('px', ''));

export const computeVerticalOffset = (ref: React.RefObject<HTMLElement> | React.RefObject<HTMLDivElement>): number => {
  if (!ref.current) {
    return 0;
  }
  const computedStyle = window.getComputedStyle(ref.current);

  return (
    pixelToInt(computedStyle.marginTop) +
    pixelToInt(computedStyle.marginBottom) +
    pixelToInt(computedStyle.borderTopWidth) +
    pixelToInt(computedStyle.borderBottomWidth)
  );
};

export const computeActivitiesHeight = ({
  contentHeight,
  maxHeaderHeight,
  windowHeight,
  visibleHeaderHeight,
  activitiesVerticalOffset,
  containerVerticalOffset,
  maxActivitiesHeight,
}: {
  contentHeight: number;
  maxHeaderHeight: number;
  windowHeight: number;
  visibleHeaderHeight: number;
  activitiesVerticalOffset: number;
  containerVerticalOffset: number;
  maxActivitiesHeight?: number;
}): number => {
  if (maxActivitiesHeight !== undefined) {
    return maxActivitiesHeight;
  }

  let activitiesHeight = windowHeight - activitiesVerticalOffset;
  if (contentHeight + maxHeaderHeight > windowHeight) {
    activitiesHeight -= visibleHeaderHeight;
  } else {
    activitiesHeight -= maxHeaderHeight + containerVerticalOffset + 10;
  }

  if (visibleHeaderHeight > 0) {
    return activitiesHeight;
  }
  return activitiesHeight - 10;
};
